"use client";

import { Button, LoadingSpinner } from "@west-tennessee-consulting/ui";
import { HardDrive } from "lucide-react";
import type { Attachment, UploadResults } from "./SaveAttachmentsToGoogleDriveModal.types";

interface SaveAttachmentsModalActionsProps {
  attachments: Attachment[];
  /**
   * Is there somewhere to save to — the sender's company, or a folder the
   * operator picked. Replaces the old `selectedClient` gate, which forced a
   * manual pick before the button would ever enable.
   */
  hasDestination: boolean;
  isLoading: boolean;
  isUploading: boolean;
  onClose: () => void;
  onUpload: () => void;
  selectedAttachmentCount: number;
  uploadResults: UploadResults | null;
}

export function SaveAttachmentsModalActions({
  attachments,
  hasDestination,
  isLoading,
  isUploading,
  onClose,
  onUpload,
  selectedAttachmentCount,
  uploadResults,
}: SaveAttachmentsModalActionsProps) {
  const canShowUploadButton = !uploadResults && attachments && attachments.length > 0;

  return (
    <div className="flex justify-end space-x-2 pt-4">
      <Button variant="outline" onClick={onClose} disabled={isUploading || isLoading}>
        {uploadResults ? "Close" : "Cancel"}
      </Button>
      {canShowUploadButton && (
        <Button
          onClick={onUpload}
          disabled={
            !hasDestination || isUploading || isLoading || selectedAttachmentCount === 0
          }
        >
          {isUploading ? (
            <>
              <LoadingSpinner className="h-4 w-4 mr-2" />
              Saving...
            </>
          ) : (
            <>
              <HardDrive className="h-4 w-4 mr-2" />
              Save {selectedAttachmentCount} Attachment
              {selectedAttachmentCount !== 1 ? "s" : ""}
            </>
          )}
        </Button>
      )}
    </div>
  );
}
